module.exports = __webpack_public_path__ + "files/60270fcbf98ab89e9d144eca4f51fd4f.png";